import React, { useId, useMemo } from 'react';
import { FormViewerContext } from '@wix/form-viewer/widget';
import {
  PortalContainer,
  PortalContainerContext,
} from '../WixForm/PortalContainerContext';
import { WixFormDatahooks } from '../WixForm/datahooks';

type FormViewerContextProps = React.ComponentProps<typeof FormViewerContext>;

export type ScopedFormViewerContextProps = Pick<
  FormViewerContextProps,
  'host' | 'wfActions' | 'wfResults' | 'wfConfig'
> & {
  instanceId: string;
  keepUserData: boolean;
  children?: React.ReactNode;
};

export const ScopedFormViewerContext: React.FC<
  ScopedFormViewerContextProps
> = ({
  host,
  wfActions,
  wfResults,
  wfConfig,
  instanceId,
  keepUserData,
  children,
}) => {
  const compId = wfConfig?.compId;
  const fallbackCompId = useId().replace(/:/g, '');
  const portalContainer = useMemo<PortalContainer | undefined>(
    () =>
      compId
        ? ({ children: portalled }) => (
            <div
              className={`${compId} ${compId}_ooi`}
              data-hook={WixFormDatahooks.PortalContainer}
            >
              {portalled}
            </div>
          )
        : undefined,
    [compId],
  );

  return (
    <PortalContainerContext.Provider value={portalContainer}>
      <FormViewerContext
        host={host}
        wfActions={wfActions}
        wfResults={wfResults}
        wfConfig={{
          ...wfConfig,
          compId: `${compId ?? fallbackCompId}-${instanceId}`,
          ...(keepUserData ? {} : { userData: undefined }),
        }}
      >
        {children}
      </FormViewerContext>
    </PortalContainerContext.Provider>
  );
};
